<template>
    <svg
        width="80"
        height="77.779999"
        viewBox="0 0 80 77.779999"
        fill="none"
        version="1.1"
        id="svg1"
        sodipodi:docname="ArrowRight.svg"
        inkscape:version="1.4 (e7c3feb100, 2024-10-09)"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:svg="http://www.w3.org/2000/svg">
        <defs
            id="defs1" />
        <sodipodi:namedview
            id="namedview1"
            pagecolor="#ffffff"
            bordercolor="#000000"
            borderopacity="0.25"
            inkscape:showpageshadow="2"
            inkscape:pageopacity="0.0"
            inkscape:pagecheckerboard="0"
            inkscape:deskcolor="#d1d1d1"
            inkscape:zoom="8.5"
            inkscape:cx="60"
            inkscape:cy="69"
            inkscape:window-width="2560"
            inkscape:window-height="1382"
            inkscape:window-x="0"
            inkscape:window-y="0"
            inkscape:window-maximized="1"
            inkscape:current-layer="svg1" />
        <path
            d="M 60.859999,33.89 H 0 v 10 h 60.859999 l -26.82,26.82 7.07,7.07 38.89,-38.89 -38.89,-38.89 -7.07,7.07 z"
            fill="#1c1c1c"
            id="path1" />
    </svg>
</template>

<script>
  export default {
    name: 'IconArrowShort'
  }
</script>
